import React from 'react'

class PageBody extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        windowHeight: window.innerHeight
      }
    }
    
    componentDidMount(){
      this.resize()
      window.addEventListener('resize', this.resize)
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.resize)
    }
    resize = () => {
      this.setState({
        windowHeight: window.innerHeight
      })
    }
    render(){
      return(
        <div id="body" role="main" style={this.state.windowHeight && this.state.windowHeight > 768 ? {} : {minHeight:"700px"}}>
           {this.props.children}
        </div>
      )
    }
  }

  export default PageBody